import React from 'react';
import { KRINA_INSTITUTES } from '../data/institutes';

/**
 * InstitutesMarquee
 * -----------------
 * Auto-scrolling, infinite, pause-on-hover marquee of the institutions
 * Krina has trained at or is professionally affiliated with.
 *
 * Uses pure CSS keyframe animation (no JS) for smoothness. The track
 * renders the list twice so the loop is seamless. Logos are rendered
 * inside a fixed-height tile with object-fit:contain so disparate
 * aspect ratios sit cleanly.
 */
const InstitutesMarquee = () => {
  // Render twice so the keyframe -50% translate produces a seamless loop.
  const reel = [...KRINA_INSTITUTES, ...KRINA_INSTITUTES];

  return (
    <div className="institutes-marquee" data-testid="institutes-marquee" aria-label="Institutions Krina is affiliated with">
      <p className="institutes-marquee-eyebrow">Trained &amp; affiliated with</p>
      <div className="institutes-marquee-viewport">
        <div className="institutes-marquee-track" role="list">
          {reel.map((inst, idx) => {
            const hasLink = Boolean(inst.href);
            const Tag = hasLink ? 'a' : 'div';
            const linkProps = hasLink
              ? { href: inst.href, target: '_blank', rel: 'noopener noreferrer' }
              : {};
            return (
              <Tag
                key={`${inst.id}-${idx}`}
                {...linkProps}
                className={`institutes-marquee-tile${hasLink ? '' : ' is-unlinked'}`}
                role="listitem"
                aria-label={`${inst.name} — ${inst.role}`}
                title={`${inst.name} · ${inst.role}`}
                data-testid={`institute-tile-${inst.id}`}
              >
                <img src={inst.logo} alt={inst.alt} loading="lazy" />
                <span className="institutes-marquee-caption">{inst.shortName}</span>
              </Tag>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InstitutesMarquee;
